<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">
          <div class="bg-white p-3 rounded-3">
            <div>
              <h2 class="display-3 text-custom-text">品牌系列</h2>
            </div>
            <div class="mt-3"></div>

            <div v-if="isLoading && items.length === 0" class="text-center mb-3 d-flex justify-content-center p-4">
              <b-spinner label="Loading..."></b-spinner>
            </div>

            <div class="grid-container mx-5">
              <div v-for="(item, index) in items" :key="index" class="grid-item">
                <BrandItem style="width: 212px; height: 214px;" :item="item"></BrandItem>
              </div>
            </div>
            <IntersectionObserver
                sentinal-name="brand-sentinel"
                @on-intersection-element="onIntersectionElement"
            />
            <div v-if="isLoadMore || finished" class="d-flex w-100 mt-3 justify-content-center align-items-center">
              <b-spinner v-if="isLoadMore" label="Loading..."></b-spinner>
              <p v-if="finished">已無更多資料</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import BrandItem from "@/views/components/elements/BrandItem";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import {getMediaUrl} from "@/util/helpers";
import * as Api from "@/util/http_api";

export default {
  name: "BrandView",
  components: {
    BrandItem,
    IntersectionObserver,
  },
  data() {
    return {
      isLoading: false,
      finished: false,
      items: [],
      total_counts: 0,
      isIntersectingElement: false,
      isLoadMore: false,
      itemsPerPage: 24,
    };
  },
  async created() {
    await this.getDataFromApi();
  },
  methods: {
    getMediaUrl,
    onIntersectionElement(value) {
      this.isIntersectingElement = value;
      this.loadMore();
    },
    async loadMore() {
      if (this.isLoading || this.isLoadMore || this.finished) return;
      this.isLoadMore = true;
      const data = await Api.getBrands(this.itemsPerPage, this.items.length);
      for (let i = 0; i < data.items.length; i++) {
        this.items.push(data.items[i]);
      }
      this.isLoadMore = false;
      this.finished = this.items.length >= this.total_counts;
    },
    async getDataFromApi() {
      this.isLoading = true;
      try {
        const data = await Api.getBrands(this.itemsPerPage, 0);
        this.items = data.items;
        this.total_counts = data.total;
        this.finished = this.items.length >= this.total_counts;
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
}

.grid-item {
  padding: 0;
}
</style>
